<template>
  <div>
    <div class="font-bold text-size-7 tablet:text-size-5">{{ title }}</div>
    <div class="flex gap-[5px]">
      <CountdownDigit
        v-for="(digit, index) in digits"
        :key="index"
        :value="digit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  value: number
}>()

const digits = computed<string[]>(() => {
  const str = props.value.toString()
  return str.padStart(2, '0').split('')
})
</script>
